module.exports = __webpack_public_path__ + "static/img/3areaB_16.c8b351f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_16.png
// module id = 1167
// module chunks = 1